import ElInputTag from './custom-Input-tag.vue'

export { ElInputTag }

export default {
    install(Vue) {
        Vue.component('custom-input-tag', ElInputTag)
    }
}
